module.exports = __webpack_public_path__ + "static/media/Blyant.278ab491.PNG";